// Entry point for the build script in your package.json
import Rails from "@rails/ujs"
Rails.start()

import "./src/jquery"
import 'jquery-ui'
import * as bootstrap from 'bootstrap'
import Highcharts from 'highcharts'
import 'highcharts/highcharts-more'
import Bloodhound from 'typeahead.js/dist/bloodhound.min.js'
import typeahead from 'typeahead.js/dist/typeahead.bundle.min.js'
import 'bootstrap-filestyle'

window.Bloodhound = Bloodhound

import toastr from 'toastr'

import "./src/custom"
import "./src/ess_highcharts"
import "./src/projects"
import "./src/quotations"
import "./src/runs"
import "./src/sample_sets"
import "./src/sequencing_requests"

// Make Highcharts available globally
window.Highcharts = Highcharts

// Display flash messages using toastr
window.displayFlashMessage = function(type, message) {
  toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "2000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  }
  toastr[type](message)
}
